<div class="container-fluid p-0">
  <!-- header code start -->
  <div class="main-header row">
    <div class="col-md-4 col-12">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-start">
          <h6 class="m-h6">finance for non financials</h6>
          <div>
            <div class="edit-pen">
              <img
                class=""
                src="../../../../assets/icones-2025/edit.png"
                alt="loading..."
              />
            </div>
          </div>
        </div>
        <div class="d-flex align-items-start">
          <p class="m-p">
            استنكار النشوة وتمجيد الألم نشأت بالفعل، وسأعرض لك التفاصيل لتكتشف
            حقيقة وأساس تلك السعادة البشرية، فلا أحد يرفض أو يكره أو يتجنب
            الشعور بالسعادة، ولكن بفضل هؤلاء الأشخاص
          </p>
          <div>
            <div class="edit-pen">
              <img
                class=""
                src="../../../../assets/icones-2025/edit.png"
                alt="loading..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mob-web-flex col-md-8 col-12">
      <div class="mob-web-flex">
        <div class="profile">
          <div class="d-flex">
            <div class="d-flex justify-content-center align-items-center">
              <img
                class="profile-img"
                src="https://static.vecteezy.com/system/resources/thumbnails/029/364/941/small_2x/3d-carton-of-boy-going-to-school-ai-photo.jpg"
                alt="loading..."
              />
            </div>
            <div class="profile-text">
              <p class="profile-p">Coach</p>
              <h6 class="profile-h6">Zaid Izhar Siddiq</h6>
            </div>
          </div>
        </div>
        <div class="start-end-date">
          <div class="d-flex justify-content-between">
            <div class="start-date">
              <div class="d-flex align-items-center">
                <img
                  class="start-icone"
                  src="../../../../assets/icones-2025/schedule.png"
                  alt="loading..."
                />
                <p class="start-end-p">Start date</p>
              </div>
              <div class="date">Nov-30-2024</div>
            </div>
            <div class="d-flex align-items-center mx-2">
              <i class="full-stop"></i>
              <div class="time-bar"></div>
              <i class="fa-solid fa-play icon-purple"></i>
            </div>
            <div class="end-date">
              <div class="d-flex align-items-center">
                <img
                  class="start-icone"
                  src="../../../../assets/icones-2025/avg_pace.png"
                  alt="loading..."
                />
                <p class="start-end-p">Start date</p>
              </div>
              <div class="date">Nov-01-2024</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- header code end -->

  <!-- training content code start -->
  <div class="content">
    <div class="d-flex justify-content-end">
      <div class="d-flex multi-btn">
        <div class="multi-btn-active">
          Syncronius
          <img
            class="mx-2 mob-width"
            src="../../../../assets/icones-2025/calendar_month.png"
            alt="loading..."
          />
        </div>
        <div class="multi-btn-dactive">
          Asyncronius
          <img
            class="mx-2 mob-width"
            src="../../../../assets/icones-2025/list_alt.png"
            alt="loading..."
          />
        </div>
      </div>
    </div>
    <div class="d-flex pos-rel flex-column">
      <div class="sticky-border"></div>
      <div class="training-bar d-flex">
        <div class="main-content-bar">
          <div class="date-box pos-rel">
            <div class="cross">
              <img
                class=""
                src="../../../../assets/icones-2025/close_small.png"
                alt="loading..."
              />
            </div>
            <h6 class="month">Nov</h6>
            <h6 class="day">07</h6>
            <h6 class="year">2024</h6>
          </div>
        </div>
        <div class="training-data">
          <div class="training-cards">
            <div class="training-cards-img pos-rel">
              <span class="red-dot"></span>
              <img
                class="card-img"
                src="https://plus.unsplash.com/premium_vector-1711987493316-bbdbb5cb530a?q=80&w=2360&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1559583985-c80d8ad9b29f?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1586115176305-0dbffc809ed5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1530912780732-0d2507ded3e8?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1542397284385-6010376c5337?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://i.pinimg.com/736x/68/8d/d3/688dd325dbbdc238f4b70caffe77a5af.jpg"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- training content code end -->

      <!-- dotted borders code start -->
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <!-- dotted borders code End -->

      <!-- training active content code start -->
      <div class="training-bar d-flex">
        <div class="main-content-bar">
          <div class="date-box pos-rel">
            <div class="lock">
              <img
                class=""
                src="../../../../assets/icones-2025/lock.png"
                alt="loading..."
              />
            </div>
            <h6 class="month">Nov</h6>
            <h6 class="day">07</h6>
            <h6 class="year">2024</h6>
          </div>
        </div>
        <div class="training-data training-data-active">
          <div class="training-cards training-cards-active">
            <div class="training-cards-img pos-rel">
              <span class="red-dot"></span>
              <img
                class="card-img"
                src="https://plus.unsplash.com/premium_vector-1711987493316-bbdbb5cb530a?q=80&w=2360&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1559583985-c80d8ad9b29f?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1586115176305-0dbffc809ed5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1530912780732-0d2507ded3e8?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1542397284385-6010376c5337?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://i.pinimg.com/736x/68/8d/d3/688dd325dbbdc238f4b70caffe77a5af.jpg"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- dotted borders code start -->
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <!-- dotted borders code End -->

      <!-- training active content code end -->

      <!-- training active content code start -->
      <div class="training-bar d-flex">
        <div class="main-content-bar">
          <div class="date-box pos-rel">
            <div class="lock">
              <img
                class=""
                src="../../../../assets/icones-2025/lock.png"
                alt="loading..."
              />
            </div>
            <h6 class="month">Nov</h6>
            <h6 class="day">07</h6>
            <h6 class="year">2024</h6>
          </div>
        </div>
        <div class="training-data training-data-active">
          <div class="training-cards training-cards-active">
            <div class="training-cards-img pos-rel">
              <span class="red-dot"></span>
              <img
                class="card-img"
                src="https://plus.unsplash.com/premium_vector-1711987493316-bbdbb5cb530a?q=80&w=2360&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1559583985-c80d8ad9b29f?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1586115176305-0dbffc809ed5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1530912780732-0d2507ded3e8?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://images.unsplash.com/photo-1542397284385-6010376c5337?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img
                class="card-img"
                src="https://i.pinimg.com/736x/68/8d/d3/688dd325dbbdc238f4b70caffe77a5af.jpg"
                alt="loading..."
              />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img
                    class=""
                    src="../../../../assets/icones-2025/pending_actions.png"
                    alt="loading..."
                  />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- dotted borders code start -->
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <!-- dotted borders code End -->

      <!-- training active content code end -->
    </div>
  </div>
</div>

<div class="container-fluid p-0">
  <!-- header code start -->
  <div class="main-header row">
    <div class="col-md-4 col-12">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-start">
          <h6 class="m-h6">finance for non financials</h6>
          <div>
            <div class="edit-pen">
              <img
                class=""
                src="../../../../assets/icones-2025/edit.png"
                alt="loading..."
              />
            </div>
          </div>
        </div>
        <div class="d-flex align-items-start">
          <p class="m-p">
            استنكار النشوة وتمجيد الألم نشأت بالفعل، وسأعرض لك التفاصيل لتكتشف
            حقيقة وأساس تلك السعادة البشرية، فلا أحد يرفض أو يكره أو يتجنب
            الشعور بالسعادة، ولكن بفضل هؤلاء الأشخاص
          </p>
          <div>
            <div class="edit-pen">
              <img
                class=""
                src="../../../../assets/icones-2025/edit.png"
                alt="loading..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mob-web-flex col-md-8 col-12">
      <div class="mob-web-flex">
        <div class="profile">
          <div class="d-flex">
            <div class="d-flex justify-content-center align-items-center">
              <img
                class="profile-img"
                src="https://static.vecteezy.com/system/resources/thumbnails/029/364/941/small_2x/3d-carton-of-boy-going-to-school-ai-photo.jpg"
                alt="loading..."
              />
            </div>
            <div class="profile-text">
              <p class="profile-p">Coach</p>
              <h6 class="profile-h6">Zaid Izhar Siddiq</h6>
            </div>
          </div>
        </div>
        <div class="start-end-date">
          <div class="d-flex justify-content-between">
            <div class="start-date">
              <div class="d-flex align-items-center">
                <img
                  class="start-icone"
                  src="../../../../assets/icones-2025/schedule.png"
                  alt="loading..."
                />
                <p class="start-end-p">Start date</p>
              </div>
              <div class="date">Nov-30-2024</div>
            </div>
            <div class="d-flex align-items-center mx-2">
              <i class="full-stop"></i>
              <div class="time-bar"></div>
              <i class="fa-solid fa-play icon-purple"></i>
            </div>
            <div class="end-date">
              <div class="d-flex align-items-center">
                <img
                  class="start-icone"
                  src="../../../../assets/icones-2025/avg_pace.png"
                  alt="loading..."
                />
                <p class="start-end-p">Start date</p>
              </div>
              <div class="date">Nov-01-2024</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- header code end -->

  <!-- training content code start -->
  <div class="content">
    <div class="d-flex justify-content-end">
      <div class="d-flex multi-btn">
        <div class="multi-btn-active">
          Syncronius
          <img
            class="mx-2 mob-width"
            src="../../../../assets/icones-2025/calendar_month.png"
            alt="loading..."
          />
        </div>
        <div class="multi-btn-dactive">
          Asyncronius
          <img
            class="mx-2 mob-width"
            src="../../../../assets/icones-2025/list_alt.png"
            alt="loading..."
          />
        </div>
      </div>
    </div>
    <div class="d-flex pos-rel flex-column">
      <div class="sticky-border"></div>
      <div class="training-bar d-flex">
        <div class="main-content-bar">
          <div class="date-box pos-rel">
            <div class="cross">
              <img
                class=""
                src="../../../../assets/icones-2025/close_small.png"
                alt="loading..."
              />
            </div>
            <h6 class="month">Nov</h6>
            <h6 class="day">07</h6>
            <h6 class="year">2024</h6>
          </div>
        </div>
        <div class="training-data">
          <div class="training-cards">
            <div class="add-training-cards">
              <div>
                <img
                  class=""
                  src="../../../../assets/icones-2025/add_2.png"
                  alt="loading..."
                />
              </div>
              <div class="add-training-text">Add Materials</div>
            </div>
          </div>
        </div>
      </div>
      <!-- training content code end -->

      <!-- dotted borders code start -->
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <!-- dotted borders code End -->
    </div>
  </div>
</div>
